export default __webpack_public_path__ + "static/bbb-56935c528c29a8ea695772cc66ad189e.png";